<template>
  <div class="big-map-box">
    <div class="map-title">{{ title }}</div>
    <div class="map-content" id="Gridmap"></div>
    <div class="map-darkcorner"></div>
    <div @click="layer.setFitView()" class="set-fitview" v-if="fitviewBtnFlag">归位</div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'Gridmap',
  props: {
    title: {
      type: String,
      default: ''
    },
    // 控制角度和网格高度
    pitch: {
      type: Number,
      default: 30
    },
    opacity: {
      type: Number,
      default: 0.9
    },
    // 网格大小
    radius: {
      type: Number,
      default: 1000
    },
    colorList: {
      type: Array,
      default() {
        return ['#0080ff', '#00cdff', '#00d8ae', '#a1e058', '#ffe05f']
      }
    },
    gridData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      map: null,
      layer: null,
      fitviewBtnFlag: false
    }
  },
  mounted() {
    this.initChart()
  },
  methods: {
    initChart() {
      this.map = new AMap.Map('Gridmap', {
        mapStyle: 'amap://styles/b5500447492ee5d38f79824b6e68aec4',
        viewMode: '3D',
        pitch: this.pitch
      })
      setInterval(() => {
        this.map.on('mapmove', () => {
          this.fitviewBtnFlag = true
        })
      }, 1000)
      this.initLayer()
    },
    initLayer() {
      this.layer = new Loca.GridLayer({
        map: this.map
      })

      this.layer.setData(this.gridData, {
        lnglat: obj => {
          var val = obj.value
          return [val['lng'], val['lat']]
        },
        value: 'count',
      })

      this.layer.setOptions({
        unit: 'meter',
        mode: 'count',
        style: {
          color: this.colorList,
          radius: this.radius,
          opacity: this.opacity,
          gap: 150,
          height: [
            this.pitch ? this.pitch * 20 + 2000 : 0,
            this.pitch ? this.pitch * 50 + 5000 : 0
          ]
        }
      })

      this.layer.render()
      this.layer.setFitView()
    }
  }
}
</script>

<style scoped lang="less">
</style>
